export default __webpack_public_path__ + "static/media/27195259307c7b4f24d1d8b86abd33e2.jpg";